import campaignCentralOverlay from './central-overlay';
import campaignEndBanner from './end-banner';
export default function campaignOverlayInit ( campaignData ) {
	if ( campaignData ) {
		const { endBanner, exitOverlay: centralOverlay } = campaignData;
		if ( centralOverlay ) {
			campaignCentralOverlay( centralOverlay );
		}

		if ( endBanner ) {
			campaignEndBanner( endBanner );
		}
	}
}
